import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ROUTES } from "api";
import { getClientCredentials } from "services/auth.service";

import { baseApi } from "../baseAPI";

const passportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    validatePassport: builder.mutation({
      queryFn: async (imageData, queryApi, extraOptions, _fetchWithBQ) => {
        try {
          // Get credentials first
          const { clientId, clientSecret, uniqueDeviceIdentifier } =
            await getClientCredentials();

          // Create a custom fetch without Content-Type header for FormData
          const customFetch = fetchBaseQuery({
            baseUrl: window._env_?.REACT_APP_API_URL,
            prepareHeaders: (headers) => {
              // Don't set Content-Type - let browser handle it for FormData
              headers.set("shared-key", window._env_?.REACT_APP_SHARED_KEY);
              headers.set("device-id", uniqueDeviceIdentifier);
              headers.set("client-id", clientId);
              headers.set("client-secret", clientSecret);

              return headers;
            },
          });

          // imageData is now FormData containing the passport image
          // Call customFetch with proper RTK Query context
          const result = await customFetch(
            {
              url: ROUTES.validatePassport,
              method: "POST",
              body: imageData,
            },
            queryApi,
            extraOptions
          );

          if (result?.error) {
            const backendMessage =
              result.error?.data?.message ||
              "An error occurred while validating the passport.";

            return {
              data: {
                status: "error",
                message: backendMessage,
                // Reason: preserve raw message and HTTP status for error classification
                messageLong: backendMessage,
                statusCode: result.error?.status,
              },
            };
          }

          return {
            data: {
              status: "success",
              data: {
                result: result.data?.data?.result ?? false,
                passportData: result.data?.data?.passportData ?? null,
              },
              timestamps: result.data?.data?.timestamps ?? null,
            },
          };
        } catch (error) {
          return {
            error: {
              status: "error",
              message: "An error occurred while processing your request",
            },
          };
        }
      },
    }),
  }),
});

export const { useValidatePassportMutation } = passportApi;
